import { ApproveDeviceSucceededType } from './../../features/devices/approveDevice/redux/actions';
/*External dependencies*/
import { Action } from "redux";
import { StateObservable } from "redux-observable";
import { filter, mergeMap, withLatestFrom } from "rxjs";

/*Local dependencies*/
import { listDevicesRequest } from '../../features/devices/listDevices/redux/actions';
import { UpdateUserPointsInput, updateUserPointsRequest } from "../../features/users/updateUserPoints/redux/actions";
import { RootState } from './../../../../redux/ssr-store';
import { CreateDeviceActions, CreateDeviceSucceededType } from './../../features/devices/createDevice/redux/actions';
import { Observable, of } from "rxjs";
import { ApproveDeviceActions } from "../../features/devices/approveDevice/redux/actions";

export function onCreateDeviceEpic(
  action$: Observable<Action>,
  state$: StateObservable<RootState>
): Observable<Action> {
  return action$.pipe(
    filter( ( action: CreateDeviceSucceededType ) => action.type === CreateDeviceActions.CREATE_DEVICE_SUCCEEDED ),

    withLatestFrom( state$ ),

    mergeMap( ( [action, state] ) => {
      const id = state.AuthReducer.id;
      const updateUserPointsInput: UpdateUserPointsInput = { id, userPoints: 25 };

      return of(
        listDevicesRequest( {} ),
        updateUserPointsRequest( updateUserPointsInput )
      );
    } )
  );
}


export function onApproveDeviceEpic(
  action$: Observable<Action>,
  state$: StateObservable<RootState>
): Observable<Action> {
  return action$.pipe(
    filter( ( action: ApproveDeviceSucceededType ) => action.type === ApproveDeviceActions.APPROVE_DEVICE_SUCCEEDED ),

    withLatestFrom( state$ ),

    mergeMap( ( [action, state] ) => {
      const id = state.AuthReducer.id;
      const updateUserPointsInput: UpdateUserPointsInput = { id, userPoints: 50 };

      return of(
        listDevicesRequest( {} ),
        updateUserPointsRequest( updateUserPointsInput )
      );
    } )
  );
}
